import { NbMenuItem } from '@nebular/theme';
import { PermissionPageGuard } from 'app/shared/auth/permission-page.guard';
import { AppPrivileges } from 'app/shared/enums/app-privileges.enum';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'menu.dashboard',
    icon: 'pie-chart-outline',
    link: '/dashboard',
    data: {
      canActivate: [PermissionPageGuard],
      permission: AppPrivileges.DASHBOARD,
    },
  },
  {
    title: 'menu.ledger',
    icon: 'book-open-outline',
    link: '/ledger',
    data: {
      canActivate: [PermissionPageGuard],
      permission: AppPrivileges.LEDGER,
    },
  },
  {
    title: 'menu.reports',
    icon: 'file-text-outline',
    link: '/reports',
    data: {
      canActivate: [PermissionPageGuard],
      permission: AppPrivileges.REPORTS,
    },
  },
  {
    title: 'menu.bulkUpload',
    icon: 'cloud-upload-outline',
    link: '/bulkupload',
    data: {
      canActivate: [PermissionPageGuard],
      permission: AppPrivileges.BULKUPLOAD,
    },
  },
  {
    title: 'menu.backToEtech',
    icon: 'arrowhead-left-outline',
    link: '/back-to-etech',
    data: {
      canActivate: [PermissionPageGuard],
      permission: AppPrivileges.BACKTOETECH,
    },
  },
];
